import { useUpgradeSdaiDialog } from './logic/useUpgradeSdaiDialog'
import { UpgradeSdaiView } from './views/UpgradeSdaiView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { SuccessView } from '@/features/dialogs/common/views/SuccessView'
import { withSuspense } from '@/ui/utils/withSuspense'

interface UpgradeSdaiDialogContentContainerProps {
  closeDialog: () => void
}

function UpgradeSdaiDialogContentContainer({ closeDialog }: UpgradeSdaiDialogContentContainerProps) {
  const {
    sdai,
    susds,
    pageStatus,
    migrationAmount,
    actionsViewState,
    form,
    assetsFields,
    selectableAssets,
    txOverview,
  } = useUpgradeSdaiDialog()

  if (pageStatus.state === 'success') {
    return (
      <SuccessView
        tokenWithValue={{ token: sdai, value: migrationAmount }}
        proceedText="Back to Savings"
        objectiveType="upgradeSdai"
        onProceed={closeDialog}
        className="p-6"
      />
    )
  }

  return (
    <UpgradeSdaiView
      sdai={sdai}
      susds={susds}
      actionsViewState={actionsViewState}
      form={form}
      assetsFields={assetsFields}
      selectableAssets={selectableAssets}
      txOverview={txOverview}
    />
  )
}

const UpgradeDialogContentContainerWithSuspense = withSuspense(UpgradeSdaiDialogContentContainer, DialogContentSkeleton)
export { UpgradeDialogContentContainerWithSuspense as UpgradeDialogContentContainer }
